// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
// Container imports
const collectionActions = require('../collection/actions')
// Sibling imports
const CollectionProfileHeader = require('./component-dumb')

function mapStateToProps(state) {
  return {
    collection: state.collection
  }
}

const mapDispatchToProps = {
  onUserClick: collectionActions.navigateToCollectionUserProfile
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withImmutableToJS(
    CollectionProfileHeader
  )
)
